import React, { useImperativeHandle } from "react";


const items = [
	// {
	//   icon: 'message-square',
	//   name: 'In-App Chat'
	// },
	{
	  icon: 'phone',
	  name: 'Local Phone'
	},
	{
	  icon: 'mail',
	  name: 'Email'
	},
	{
	  icon: 'message-circle',
	  name: 'Whatapp'
	},
	{
	  icon: 'video',
	  name: 'Zoom Meeting'
	},
	{
	  icon: 'plus',
	  name: 'Google Meet'
	}
  ]

const DEFAULT = items.map((e) => { return e.name });


const CommunicationFilter =  React.forwardRef(({ rtl }, ref) => {
	const [values, setValues] = React.useState(DEFAULT);


    useImperativeHandle(ref, () => ({
        reset: () => reset(),
        getValues: () => {
            return values
        }
      }));

    const reset = () => setValues(DEFAULT);

	const handleSelect = (name) => {
		if(values.includes(name)){
			setValues([...values.filter(e => e !== name)]);
		}else{
			setValues([...values, name])
		}
	}
    

	return (
		<div className="form-fieldset">
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					marginBottom: 10
				}}
			>
				<h6 style={{ fontWeight: 600, margin: 0 }}>Communications</h6>
				<button onClick={reset} className="clear-button">
					Reset
				</button>
			</div>
			
			<div class="filters-card">
				<div class="checkboxes-list">
					<div class="field">
						{(items || []).map((item, i) => {
							return (
								<div class="control" style={{ cursor: "pointer" }} onClick={() => handleSelect(item.name)}>
									<label class="checkbox pt-2 pb-2">
										<input
											className="d-none"
											type="checkbox"
											onChange={(e) =>
												null//updateProfile({ [item.key]: e.target.checked })
											}
											name={item.name}
											// defaultChecked={
											// 	PROFILE[item.key] ?? false
											// }
										/>
										{item.name}
									</label>
									<i className={`checkbox-box mdi mdi-checkbox-${values.includes(item.name) ? "marked" : "blank"}-outline`} />
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
});



export default CommunicationFilter;

